import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { OG_IMAGE, OG_IMAGE_ALT, SITE_URL, getPageSeo } from "../../data/seo";

// Writes the active route into the document head. The tags themselves already
// exist in public/index.html (so a no-JS crawler still has the homepage card);
// this only updates content, it does not invent a second set of tags.
//
// Social crawlers that do not run JavaScript will keep seeing the homepage
// card even on an article URL. That is a limit of a client-rendered app, not
// of these tags. Googlebot does run the app, so the per-page title and
// description are what it indexes.

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function DocumentHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getPageSeo(pathname);
    const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    const image = seo.image || OG_IMAGE;
    const imageAlt = seo.image ? seo.imageAlt : OG_IMAGE_ALT;

    document.title = seo.title;
    setMeta("name", "robots", seo.noindex ? "noindex, nofollow" : "index, follow");
    setMeta("name", "description", seo.description);
    setMeta("property", "og:title", seo.title);
    setMeta("property", "og:description", seo.description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:secure_url", image);
    setMeta("property", "og:image:alt", imageAlt);
    setMeta("name", "twitter:title", seo.title);
    setMeta("name", "twitter:description", seo.description);
    setMeta("name", "twitter:image", image);
    setMeta("name", "twitter:image:alt", imageAlt);
    setCanonical(url);
  }, [pathname]);

  return null;
}

export default DocumentHead;
